/** Ogg/Opus 识别头（单声道、48 kHz），WebCodecs Opus 编解码共用 */

let warnedOpusWebCodecsUnsupported = false;

export function notifyOpusWebCodecsUnsupportedOnce(): void {
  if (warnedOpusWebCodecsUnsupported) {
    return;
  }
  warnedOpusWebCodecsUnsupported = true;
  try {
    window.alert('当前浏览器不支持 WebCodecs Opus，请使用最新版谷歌 Chrome 或夸克浏览器。');
  } catch {
    /* ignore */
  }
}

export function buildOpusHeadMono48k(): Uint8Array {
  const b = new Uint8Array(19);
  b.set([0x4f, 0x70, 0x75, 0x73, 0x48, 0x65, 0x61, 0x64]);
  b[8] = 1;
  b[9] = 1;
  const v = new DataView(b.buffer);
  v.setUint16(10, 0, true);
  v.setUint32(12, 48000, true);
  v.setInt16(16, 0, true);
  b[18] = 0;
  return b;
}
